export default __webpack_public_path__ + "static/media/marketplaceCover.d9f4b8e5.jpg";